'use client';

import { Suspense } from "react";
import Image from "next/image";
import Link from "next/link";
import { useSearchParams } from "next/navigation";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { isDevMode } from "@/lib/dev-mode";

function LoginForm() {
  const searchParams = useSearchParams();
  const returnTo = searchParams.get('returnTo') || '/';

  // In v4, use <a> tags with /auth/login instead of buttons with onClick
  // Auth0 SDK automatically handles the redirect
  const loginHref = isDevMode() 
    ? returnTo 
    : `/auth/login?returnTo=${encodeURIComponent(returnTo)}`;

  return (
    <div className="w-full h-screen flex items-center justify-center bg-devtech-background">
      <div className="flex items-center justify-center py-12 w-full">
        <Card className="mx-auto max-w-sm w-full">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
                <Image 
                  src="/logo.png" 
                  alt="DevTech" 
                  width={150} 
                  height={35}
                  unoptimized
                  priority
                />
            </div>
            <CardTitle className="text-2xl">Welcome</CardTitle>
            <CardDescription>
              {isDevMode() 
                ? "Development Mode - No Authentication Required" 
                : "Log in to continue to All Applications."
              }
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid gap-4">
              <Link
                href={loginHref}
                className="w-full bg-devtech-primary hover:bg-devtech-primary/90 text-white text-center py-2 px-4 rounded-md font-medium transition-colors"
              >
                {isDevMode() ? "Continue to Dashboard" : "Continue with Auth0"}
              </Link>
              <div className="mt-4 text-center text-sm">
                Don&apos;t have an account?{" "}
                <Link href="#" className="underline text-devtech-primary">
                  Sign up
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default function LoginPage() {
  return (
    <Suspense fallback={
      <div className="w-full h-screen flex items-center justify-center">
        <div className="text-center">Loading...</div>
      </div>
    }>
      <LoginForm />
    </Suspense>
  );
}
